// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hard-drive"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21H21V15H3V21Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 15H21M3 3H21V21H3V3ZM6.99805 17.998H7.00195V18.002H6.99805V17.998ZM9.99805 17.998H10.002V18.002H9.99805V17.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HardDriveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hard-drive',
    ref,
    icon: element,
  },
));

HardDriveIcon.displayName = 'HardDriveIcon';

export default HardDriveIcon;
